/**
 * ContactDot — at-a-glance contact indicator for list rows.
 *
 *  • Green = contacted within the last 7 days
 *  • Amber = contacted but > 7 days (a "follow up" nudge)
 *  • Nothing rendered if never contacted (don't pollute the row)
 *
 * Tooltip ("title" attribute) exposes who reached out + how long ago.
 */
import { isContactStale, lastContactedLabel } from "@/lib/contactTracker";

export default function ContactDot({ lastContactedAt, byName, className = "" }) {
    if (!lastContactedAt) return null;
    const stale = isContactStale(lastContactedAt, 7);
    const when = lastContactedLabel(lastContactedAt);
    const who = byName || "—";
    const title = stale
        ? `Last emailed by ${who} · ${when} — follow up`
        : `Last emailed by ${who} · ${when}`;
    return (
        <span
            data-testid="contact-dot"
            data-stale={stale ? "true" : "false"}
            title={title}
            aria-label={title}
            className={`inline-block w-2 h-2 rounded-full shrink-0 ${stale ? "bg-amber-400" : "bg-emerald-400"} ${className}`}
        />
    );
}
